import CenterGroups from '../../../views/centers/center-details/center-groups'

type Props = {
  id: number
}

const OlPersonalSpaceCenterGroups = ({ id }: Props) => {
  return (
    <CenterGroups
      id={id}
      mode="edit"
      permissions={['upload-documents', 'view-students', 'assign-tefl']}
    />
  )
}

export default OlPersonalSpaceCenterGroups
